import type { DeckKind } from './queries'

export type DeckStatus = 'default' | 'enabled' | 'disabled'
export type DecksSearch = { kind?: DeckKind; status?: DeckStatus; q?: string }

const KIND_VALUES: readonly string[] = ['daily_card', 'three_cards']
const STATUS_VALUES: readonly string[] = ['default', 'enabled', 'disabled']

function isKind(v: unknown): v is DeckKind {
  return typeof v === 'string' && KIND_VALUES.includes(v)
}

function isStatus(v: unknown): v is DeckStatus {
  return typeof v === 'string' && STATUS_VALUES.includes(v)
}

export function parseDecksSearch(search: Record<string, unknown>): DecksSearch {
  return {
    ...(isKind(search.kind) ? { kind: search.kind } : {}),
    ...(isStatus(search.status) ? { status: search.status } : {}),
    ...(typeof search.q === 'string' && search.q.trim() ? { q: search.q } : {}),
  }
}
